import React, { Fragment, Component } from "react";
import PropTypes from 'prop-types';
import { getSelectionText } from "store/filters/filterUtils";
import { selectionTypes } from "store/filters/selectionTypes";
import { Dropdown } from "../../blocks/Dropdown/Dropdown";
import { RangeSelector } from "../../blocks/RangeSelector/RangeSelector";

import "./SearchBar.scss";


export class SearchBar extends Component {
  slider = null;
  static propTypes = {
    searchOptionLabel: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    updateFilter: PropTypes.func.isRequired,
    selectSearchOption: PropTypes.func.isRequired,
  }
    
  buildRangeSelectorLabel(filter){
    if(!filter.options.some(o => o.selectedValue))
      return null;
    const selectedValues = filter.options.map(o => o.selectedValue);
    const selectedOptions = filter.options.map(dropdown => dropdown.options.find(o => {
      let { value } = o;
      let { selectedValue } = dropdown;
      if(typeof value !== typeof selectedValue) {
        value = String(value);
        selectedValue = String(selectedValue);
      }
      return value === selectedValue;
     }))
     .map(selectedOption => selectedOption.label);

    if(!selectedValues[1]){
      return (<div>
        <span>{selectedOptions[0]}</span>
        <span>+</span>        
      </div>);
    } 

    const from = selectedValues[0] ? selectedOptions[0] : "£0";    
    const to = selectedOptions[1];

    return (<div>
      <span>{from}</span>
      <span> - </span>
      <span>{to}</span>
    </div>);
  }

  renderRangeSelector(filter){
    return (<RangeSelector 
      key={filter.key} 
      label={filter.label}
      selectionText={this.buildRangeSelectorLabel(filter)}
      dropdowns={filter.options.map(option => ({
        ...option,
        selectionText: getSelectionText(option),
      }))}
      onChange={({key, selectedOption}) => this.props.updateFilter({
        key,
        value: selectedOption.value,
      })}
    />);
  }

  renderDropdown(filter){
    const isDisabled = this.props.isResultsLoading || (filter.options && !filter.options.length);
    return (
      <Dropdown key={filter.key}
        {...filter}
        multiColumn={filter.options.length > 10 }
        selectionText={getSelectionText(filter)}
        isDisabled={isDisabled}
        useCarousel={true}
        onChange={option => this.props.updateFilter({
          key: filter.key,
          value: option.value,
        })}
      />
    );
  }

  renderContent(){
    return (
      <Fragment>
        {this.props.filters.map(filter => filter.selectionType !== selectionTypes.range ? 
          this.renderDropdown(filter) : 
          this.renderRangeSelector(filter))
        } 
      </Fragment>
    );
  }

  changeJourney = option => this.props.selectSearchOption(option.value);
  
  render(){   
    return (
      <section className="search-bar">
        <header className="search-bar__heading">
          <Dropdown {...this.props.searchOptions} isPlain={true}  
            label={(<Fragment>
              <span>{this.props.heading}</span> <strong>{this.props.searchOptions.label}</strong>
              </Fragment>)}           
            onChange={this.changeJourney}
          / >            
        </header>
        <div className="search-bar__content">      
          {this.renderContent()}
        </div>
      </section>      
    );
  }
}

